// DS: i1.2, DS1.7.6
import React from 'react';
import cn from 'classnames';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import s from './CoreStar.scss';
const CoreStar = ({ className , size , customSize , corePackage ='core_access' , useSecondaryColor , useGradient  })=>{
    const uniqueId = useUniqueId();
    const isNewSymbol = useFlag('new_core_symbols');
    const classNames = cn(s['root'], useGradient && !isNewSymbol ? s['gradient'] : useSecondaryColor ? s['secondary-color'] : s[corePackage], size && !customSize && s[`size-${size}`], className);
    const renderStarSVG = ()=>/*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 15 15"
        }, /*#__PURE__*/ React.createElement("path", {
            d: "M0 7.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Z",
            className: s['fill-color'],
            fill: useGradient ? `url(#${uniqueId})` : undefined
        }), /*#__PURE__*/ React.createElement("path", {
            className: s['bg-color'],
            d: "m7.5 2.778 1.26 2.796 2.967.37-2.19 2.1.575 3.025L7.5 9.57l-2.612 1.5.575-3.026-2.19-2.1 2.968-.37L7.5 2.778Z"
        }), useGradient && /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
            id: uniqueId,
            x1: "15",
            y1: "0",
            x2: "-8.34465e-07",
            y2: "15",
            gradientUnits: "userSpaceOnUse"
        }, /*#__PURE__*/ React.createElement("stop", {
            stopColor: "#FF7663"
        }), /*#__PURE__*/ React.createElement("stop", {
            offset: "0.739583",
            stopColor: "#F8BC76"
        }), /*#__PURE__*/ React.createElement("stop", {
            offset: "1",
            stopColor: "#FFB35C"
        }))));
    const renderDaSymbolSVG = ()=>/*#__PURE__*/ React.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 14 15"
        }, /*#__PURE__*/ React.createElement("path", {
            className: s['fill-color'],
            d: "M7 14.5a7 7 0 100-14 7 7 0 000 14z"
        }), /*#__PURE__*/ React.createElement("path", {
            fill: "#fff",
            d: "M8.218 3.02l-.164.164-.78 1.496-.245.164H4.2V7.14h1.558l.123.164L4.2 10.522v1.68h1.68l.165-.184.779-1.496.246-.164h2.828V8.062H8.341l-.123-.164 1.68-3.218V3.02h-1.68z"
        }));
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames,
        style: customSize
    }, isNewSymbol ? renderDaSymbolSVG() : renderStarSVG());
};
CoreStar.displayName = 'CoreStar';
export default CoreStar;
